import { useTranslation } from 'react-i18next';
import { useAppConfig } from '@/api/useAppConfig';

/**
 * Port of `_Footer.cshtml`.
 *
 * The Razor version wrote the year with `document.write(new Date().getFullYear())`;
 * here it is just an expression. The "back to top" link keeps its `#top` href —
 * `_layout.scss` gives the shell an element with that id, so the browser handles
 * the scroll and no handler is needed.
 */
export function Footer() {
  const { t } = useTranslation();
  const { data: config } = useAppConfig();

  return (
    <footer className="app-footer">
      <div className="app-footer-content flex-grow-1">
        {config?.name || 'Dotty'} &copy; {new Date().getFullYear()}.{' '}
        <span className="hidden-mobile"> {t('AllRightsReserved', 'All rights reserved,')} </span>
        <span className="fw-bold">CSC Digital</span>

        {/* Not `ms-auto` any more: an auto margin consumes the whole of the free
            space, which would leave `justify-content: center` on the row with
            nothing to distribute and the text pinned left. shell.scss takes it
            out of the flow and pins it right instead, so the text can centre
            against the full width rather than against what the arrow leaves. */}
        <a href="#top" className="hidden-mobile" aria-label={t('BackToTop', 'Back to top')}>
          <svg className="sa-icon sa-thick sa-icon-primary">
            <use href="/myui/icons/sprite.svg#arrow-up" />
          </svg>
        </a>
      </div>
    </footer>
  );
}
